import React from 'react';

const SelfProjects = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'lightgray',
        paddingTop: '50px'
      }}
    >
      <div>
      <h2> Projects</h2>
        <h3> Insync health module</h3>
        <h3> CDR Analyzer</h3>
        <h3> DSRC-WIFI inter-protocol communication in vehicular environment</h3>
      </div>
    </div>
  );
};

export default SelfProjects;